import $ from 'jquery';
window.$ = window.jQuery = require('jquery');

import React, { Fragment, useCallback, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import { query, searchFacetChange } from '../Actions/FacetedSearch.action';
import { useStateWithCallbackLazy } from 'use-state-with-callback';

Foundation.addToJquery($);

const FacetedSearchGroup = ({ group }) => {
    return (
        <Fragment>
            <button
                className="form__input"
                type="button"
                data-toggle={`custom_${group.id}`}
            >
                <span>{group.label}</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-down"
                    viewBox="0 0 16 16"
                >
                    <path
                        fillRule="evenodd"
                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                    />
                </svg>
            </button>
            <div
                className="dropdown-pane"
                id={`custom_${group.id}`}
                data-dropdown
                data-auto-focus="true"
                data-close-on-click="true"
            >
                <ul className="faceted-search__group">
                    {group.options.length &&
                        group.options
                            .filter(
                                item =>
                                    item.quantity != 0 &&
                                    !isNaN(item.quantity) &&
                                    item.quantity != null,
                            )
                            .map(option => (
                                <li
                                    key={`${group.label}-${option.id}`}
                                    className="faceted-search__item"
                                >
                                    {group.isSlider ? (
                                        <div>
                                            <h2>SliderHERE</h2>
                                        </div>
                                    ) : (
                                        <FacetedFilterCheckbox
                                            item={item}
                                            group={group}
                                        />
                                    )}
                                </li>
                            ))}
                    {group.id === 'custom_corrosion_class' && (
                        <li>
                            <button
                                data-open="infoModal"
                                className="infoModal openmodal"
                            >
                                {translate('show.guide')}
                            </button>
                        </li>
                    )}
                </ul>
            </div>
        </Fragment>
    );
};

const FacetedFilterCheckbox = ({ item, group }) => {
    const dispatch = useDispatch();
    const onChange = useCallback(
        (group, item) => dispatch(searchFacetChange(group, item)),
        [dispatch],
    );
    return (
        <label className="faceted-filter">
            <input
                className="faceted-filter__input"
                type="checkbox"
                onChange={event => onChange(group, item)}
                checked={
                    group.selectedOptions != null &&
                    group.selectedOptions.includes(item.id)
                }
            />
            <span className="faceted-filter__label">
                {group.id === 'custom_corrosion_class' && (
                    <span className={`c-corrosion ${item.label.toLowerCase()}`}>
                        {item.label}
                    </span>
                )}
                {group.id !== 'custom_corrosion_class' && item.label}
                {!isNaN(item.quantity) && item.quantity != null && (
                    <span className="faceted-filter__quantity">
                        &nbsp;({item.quantity})
                    </span>
                )}
            </span>
        </label>
    );
};

const FacetedSearchTopBar = () => {
    const dispatch = useDispatch();
    const { facetFilters, navigationTheme } = useSelector(
        state => state.facetedSearch,
    );

    useEffect(() => {
        // listen to history events (back, forward) of window
        window.onpopstate =
            window.onpopstate ||
            (event => {
                dispatch(query(window.location.search.substr(1) || ''));
            });
    }, [dispatch]);

    useEffect(() => {
        if (facetFilters.length > 0) {
            $(document).foundation();
        }
    }, [facetFilters]);

    return (
        navigationTheme !== 'category' && (
            <div className="c-filter__menus">
                <button
                    type="button"
                    className="button c-filter-btn"
                    data-toggle="sideBarNavigation"
                    aria-expanded="false"
                    aria-controls="sideBarNavigation"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="20.006"
                    >
                        <path
                            d="M17 5a2 2 0 1 0 0-4 2 2 0 1 0 0 4zm0-5a3 3 0 0 1 2.959 2.5H22v1h-2.041a3 3 0 0 1-5.918 0H0v-1h14.041A3 3 0 0 1 17 0zM2.041 9.5a3 3 0 0 1 5.918 0H22v1H7.959a3 3 0 0 1-5.918 0H0v-1zM7 10a2 2 0 1 0-4 0 2 2 0 1 0 4 0zm-7 7.5h8.041a3 3 0 0 0 5.918 0H22v-1h-8.041a3 3 0 0 0-5.918 0H0zm13-.5a2 2 0 1 0-4 0 2 2 0 1 0 4 0z"
                            fill="#303e47"
                            fillRule="evenodd"
                        />
                    </svg>
                    <span id="languageButton">
                        {translate('allfilters.button')}
                    </span>
                </button>
            </div>
        )
    );
};

export default FacetedSearchTopBar;
